import {useEffect} from "react";

const useAllowOnlyOnePrimaryCaregiver = (state) => {
    useEffect(() => {
        //If the subscriber is a primary caregiver, we need to ensure that the joint subscriber is not a primary caregiver
        if (state.subscriber.primaryCaregiver && state.jointSubscriber.primaryCaregiver) {
            state.setJointSubscriber({
                ...state.jointSubscriber,
                primaryCaregiver: false
            })
        }
    }, [state.subscriber.primaryCaregiver]);

    useEffect(() => {
        //If the joint subscriber is a primary caregiver, we need to ensure that the subscriber is not a primary caregiver
        if (state.subscriber.primaryCaregiver && state.jointSubscriber.primaryCaregiver) {
            state.setSubscriber({
                ...state.subscriber,
                primaryCaregiver: false
            })
        }
    }, [state.jointSubscriber.primaryCaregiver]);
}

export default useAllowOnlyOnePrimaryCaregiver;